<template>
  <v-card class="mb-4" outlined>
    <v-card-title class="section-header">
      <v-icon left color="grey darken-1">mdi-cog</v-icon>
      {{ $t("company_settings") }}
    </v-card-title>
    <v-card-text class="pt-4">
      <v-row>
        <v-col cols="12" sm="4" class="flex-grow-1 d-flex flex-column">
          <label class="caption font-weight-bold grey--text text--darken-2 mb-2">
            {{ $t("active") }}
          </label>
          <v-switch
            v-model="restaurant.company_restaurant_settings.state"
            :false-value="0"
            :true-value="1"
            color="success"
            dense
            hide-details
            class="mt-0 pt-0"
            @change="save"
          />
        </v-col>

        <v-col cols="12" sm="4" class="flex-grow-1 d-flex flex-column">
          <label class="caption font-weight-bold grey--text text--darken-2 mb-2">
            {{ $t("credit_only") }}
          </label>
          <v-switch
            v-model="restaurant.company_restaurant_settings.is_credit"
            :false-value="0"
            :true-value="1"
            color="warning"
            dense
            hide-details
            class="mt-0 pt-0"
            @change="save"
          />
        </v-col>

        <v-col cols="12" sm="4" class="flex-grow-1 d-flex flex-column">
          <label class="caption font-weight-bold grey--text text--darken-2 mb-2">
            {{ $t("can_see_report_taken_meals") }}
          </label>
          <v-switch
            v-model="restaurant.company_restaurant_settings.check_report"
            :false-value="0"
            :true-value="1"
            color="info"
            dense
            hide-details
            class="mt-0 pt-0"
            @change="save"
          />
        </v-col>

        <v-col cols="12" sm="8" class="flex-grow-1 d-flex flex-column">
          <label class="caption font-weight-bold grey--text text--darken-2 mb-2">
            {{ $t("no_time_limit") }}
          </label>
          <v-switch
            v-model="restaurant.company_restaurant_settings.no_time_limit"
            :false-value="0"
            :true-value="1"
            color="info"
            dense
            hide-details
            class="mt-0 pt-0"
            @change="save"
          />
        </v-col>

        <!-- <v-col cols="12" sm="4" class="flex-grow-1 d-flex flex-column">
          <label class="caption font-weight-bold grey--text text--darken-2 mb-2">
            {{ $t("change_shift_names") }}
          </label>
          <v-switch
            v-model="restaurant.is_translate_shift"
            :false-value="0"
            :true-value="1"
            color="info"
            dense
            hide-details
            class="mt-0 pt-0"
            @change="save"
          />
        </v-col> -->

        <v-col cols="12" sm="12">
          <shift-management v-model="restaurant.company_restaurant_settings" :shifts-grid="10"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import hasSnackbar from "@/mixins/hasSnackbar";
import companyService from "@/services/company";
import ShiftManagement from '../dialogs/sections/ShiftManagement.vue';

export default {
  components: { ShiftManagement },
  name: "DeliverySwitches",
  mixins: [hasSnackbar],
  props: {
    restaurant: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      firstLoad: true
    };
  },
  methods: {
    save() {
      this.$emit('save');
    },
  },
  destroyed() {
    this.firstLoad = true;
  },
};
</script>
<style scoped>
.section-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}
</style>
